import React from 'react'
import { any, async, fromJSX, nothing, Redirect, Updater, Widget } from 'widgets-for-react'
import { contentFooterWidget } from '../contentFooter/contentFooterWidget'
import { contentHeaderWidget } from '../contentHeader/contentHeaderWidget'
import { CookiebarState } from '../cookiebar/cookiebarState'
import { notFoundWidget } from '../notFound/notFoundWidget'
import { Pages } from '../routes/routesState'
import { loader } from '../sharedLayout/loader'
import { blocksWidget } from './blocks/blocksWidget'
import { previewWidget } from './blocks/previewWidget'
import {
  CmsPageState,
  cmsPageStateUpdaters,
  PageWithBlocks,
  PageWithBlocksState
} from './cmsPageState'
import { PageParams } from '../../utils/routes'
import { BlocksState } from './blocks/blocksState'
import { authorAndPhotographerWidget } from '../magazinesOverview/authorAndPhotographerWidget'
import { isPreviewPage } from './pages/utils'

export const homePageWidget = (
  setCookiebarState: (_: Updater<CookiebarState>) => void,
  params: PageParams<Pages['cmsPage']> | PageParams<Pages['home']> | PageParams<Pages['previewPage']>,
  firstTimeLoading: boolean
) => (state: CmsPageState) =>
  cmsPageWidgetOrNotFoundWidget(setCookiebarState, params, firstTimeLoading)(state)

export const genericCmsPageWidget = (
  setCookiebarState: (_: Updater<CookiebarState>) => void,
  params: PageParams<Pages['cmsPage']> | PageParams<Pages['home']> | PageParams<Pages['previewPage']>,
  firstTimeLoading: boolean
) => (state: CmsPageState) =>
  cmsPageWidgetOrNotFoundWidget(setCookiebarState, params, firstTimeLoading)(state)

const cmsPageWidgetOrNotFoundWidget = (
  setCookiebarState: (_: Updater<CookiebarState>) => void,
  params: PageParams<Pages['cmsPage']> | PageParams<Pages['home']> | PageParams<Pages['previewPage']>,
  firstTimeLoading: boolean
) => (
  state: CmsPageState
): Widget<Updater<CmsPageState>> =>
  state.pageWithBlocksState.kind === 'failed'
    ? notFoundWidget(state.notFoundState).map(
        cmsPageStateUpdaters.notFoundStateUpdater
      )
    : state.pageWithBlocksState.kind === 'redirect'
    ? fromJSX(_ =>
        state.pageWithBlocksState.kind === 'redirect' ? (
          <Redirect to={state.pageWithBlocksState.to} />
        ) : (
          <></>
        )
      )
    : cmsPageWidget(setCookiebarState, params, firstTimeLoading)(state)

const cmsPageWidget = (
  setCookiebarState: (_: Updater<CookiebarState>) => void,
  params: PageParams<Pages['cmsPage']> | PageParams<Pages['home']> | PageParams<Pages['previewPage']>,
  firstTimeLoading: boolean
) => (
  state: CmsPageState
): Widget<Updater<CmsPageState>> => {
  return state.pageWithBlocksState.kind !== 'redirect'
    ? async<PageWithBlocks>(state.pageWithBlocksState, page =>
        any<Updater<PageWithBlocksState>>([
          isPreviewPage ? previewWidget(page) : nothing(),
          contentHeaderWidget(page),
          blocksWidget(setCookiebarState,params)(page.blocks).map((updater : Updater<BlocksState>) => cmsPageStateUpdaters.blocksUpdater(updater)),
          page.kind === 'article' ? authorAndPhotographerWidget(page.articleEditor, page.photographer) : nothing(),
          contentFooterWidget(page)
        ]),
        {
          loading: _ => loader(firstTimeLoading),
          unloaded: loader(firstTimeLoading)
        }
      ).map(
        cmsPageStateUpdaters.pageWithBlocksUpdater
      )
    : nothing()
    }
